import { Select } from '@mantine/core';
import { useState } from 'react';
import { mockPractices } from '../users/data/mockData';
import { FinancesPage } from './FinancesPage';

const practiceOptions = mockPractices
  .filter((p) => p.id !== 'system' && p.status === 'Active')
  .map((p) => ({ value: p.id, label: p.name }));

export function PracticeFinancesPage(): JSX.Element {
  const [selectedPracticeId, setSelectedPracticeId] = useState<string | null>(null);

  const selectedPractice = mockPractices.find((p) => p.id === selectedPracticeId);

  return (
    <FinancesPage
      loading={!selectedPracticeId}
      title="Practice Finances"
      subtitle={selectedPractice ? `Viewing finances for ${selectedPractice.name}` : 'Select a practice to view finances'}
      headerRight={
        <Select
          placeholder="Select a practice"
          data={practiceOptions}
          value={selectedPracticeId}
          onChange={setSelectedPracticeId}
          searchable
          clearable
          w={280}
        />
      }
    />
  );
}
